import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MenuItem, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import LoadingButton from '../../components/LoadingButton'
import { TextMaskZipCode } from '../../components/TextMaskCustom';
import { numberAsCurrency } from '../utils/index';

const useStyles = makeStyles((theme) => ({
  main: {
    minHeight: '620px',
    display: 'flex',
    justifyContent: 'center',
    padding: '8px 0 18px',
  },
  card: {
    width: '100%',
    maxWidth: '760px',
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    border: '1px solid #E2E7F0',
    boxShadow: '0 4px 14px rgba(0,0,0,0.08)',
    padding: '28px 32px 26px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      padding: '20px 16px 18px',
      borderRadius: '12px',
    },
  },
  title: {
    fontWeight: 700,
    marginBottom: '4px',
    color: '#2D6E2F',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '2rem',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.55rem',
    },
  },
  titleIcon: {
    color: '#2D6E2F !important',
    fill: '#2D6E2F !important',
    fontSize: '1.45rem',
    marginRight: '6px',
  },
  subtitle: {
    marginTop: '4px',
    fontSize: '1.35rem',
    color: '#2D6E2F',
    textAlign: 'center',
    width: '100%',
    lineHeight: 1.2,
    marginBottom: '18px',
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1rem',
      marginBottom: '14px',
    },
  },
  form: {
    width: '100%',
    borderRadius: '14px',
    border: '1px solid #2F7432',
    padding: '18px 18px 16px',
    backgroundColor: '#2D6E2F',
    boxSizing: 'border-box',
    boxShadow: '0 4px 10px rgba(0, 30, 96, 0.24)',
    [theme.breakpoints.down('xs')]: {
      padding: '14px',
    },
  },
  submit: {
    margin: '14px 0 0',
    borderRadius: '8px',
    backgroundColor: '#235625',
    color: '#FFFFFF',
    fontSize: '1.15rem',
    fontWeight: 700,
    minHeight: '52px',
    '&:hover': {
      backgroundColor: '#1D3F1E',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  infoBox: {
    width: '100%',
    backgroundColor: '#EAF2FF',
    border: '1px solid #E1F3E2',
    borderRadius: '12px',
    color: '#2D6E2F',
    padding: '12px 14px',
    marginBottom: '14px',
    boxSizing: 'border-box',
  },
  infoTitle: {
    fontWeight: 700,
    marginBottom: '4px',
    fontSize: '1.75rem',
    lineHeight: 1,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.35rem',
    },
  },
  infoText: {
    fontSize: '1.05rem',
    lineHeight: 1.35,
    fontWeight: 600,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.92rem',
    },
  },
  valueLabel: {
    color: '#FFFFFF',
    marginBottom: '8px',
    fontSize: '1.6rem',
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.15rem',
    },
  },
  helperText: {
    color: 'rgba(255,255,255,0.95)',
    textAlign: 'center',
    marginTop: '16px',
    fontSize: '1rem',
    lineHeight: 1.4,
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.86rem',
    },
  },
  valueDiv: {
    display: 'block'
  },
  documentsLabel: {
    color: '#FFFFFF',
    marginTop: '16px',
    marginBottom: '8px',
    fontSize: '1.6rem',
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.15rem',
    },
  },
  documentsHint: {
    color: 'rgba(255,255,255,0.95)',
    fontSize: '0.95rem',
    lineHeight: 1.4,
    fontWeight: 500,
    marginBottom: '8px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.86rem',
    },
  },
  documentInputLabel: {
    color: '#FFFFFF',
    marginTop: '10px',
    marginBottom: '6px',
    fontSize: '1.05rem',
    fontWeight: 600,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.95rem',
    },
  },
  documentsInput: {
    display: 'block',
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #D2ECD2',
    padding: '12px',
    color: '#2D6E2F',
    fontWeight: 600,
    boxSizing: 'border-box',
  },
  documentsList: {
    color: 'rgba(255,255,255,0.95)',
    fontSize: '0.9rem',
    marginTop: '6px',
    fontWeight: 500,
  },
  documentsError: {
    color: '#FFD7D7',
    fontSize: '0.9rem',
    marginTop: '6px',
    fontWeight: 600,
  },
  valueInput: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      fontSize: '2.1rem',
      fontWeight: 700,
      color: '#2D6E2F',
      '& input': {
        padding: '14px 12px',
      },
      '& fieldset': {
        borderColor: '#D2ECD2',
      },
    },
    [theme.breakpoints.down('xs')]: {
      '& .MuiOutlinedInput-root': {
        fontSize: '1.45rem',
      },
    },
  },
  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: 0,
    },
  },
  fieldInput: {
    marginBottom: '10px',
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      color: '#2D6E2F',
      fontWeight: 600,
      '& input, & .MuiSelect-select': {
        padding: '12px',
      },
      '& fieldset': {
        borderColor: '#D2ECD2',
      },
    },
    '& .MuiFormHelperText-root': {
      color: '#FFD7D7',
      fontWeight: 600,
      marginLeft: 0,
    },
  },
}));

export default function Withdrawal({ withdrawalMinimumValue, currentUser }) { // minimumWithdrawal
  const classes = useStyles();
  const [solicitarLoading, setSolicitarLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [photoDocumentFront, setPhotoDocumentFront] = useState(null);
  const [photoDocumentBack, setPhotoDocumentBack] = useState(null);
  const [addressProof, setAddressProof] = useState(null);
  // Endereço e sexo são exigidos pela capitalizadora no relatório de saques.
  // Prefill com o que o cliente já informou em saques anteriores.
  const [personalData, setPersonalData] = useState({
    sex: currentUser.sex || '',
    address_zipcode: currentUser.address_zipcode || '',
    address_street: currentUser.address_street || '',
    address_number: currentUser.address_number || '',
    address_complement: currentUser.address_complement || '',
    address_neighborhood: currentUser.address_neighborhood || '',
    address_city: currentUser.address_city || '',
    address_state: currentUser.address_state || '',
  });
  const history = useHistory();

  // Obrigatórios pro saque (complemento é opcional); espelha o contexto
  // :withdrawal do Customer no backend.
  const requiredPersonalFields = ['sex', 'address_street', 'address_number',
    'address_neighborhood', 'address_city', 'address_state'];
  const personalDataComplete =
    requiredPersonalFields.every((field) => String(personalData[field] || '').trim() !== '') &&
    personalData.address_zipcode.replace(/\D/g, '').length === 8;
  const canSubmit = !!photoDocumentFront && !!photoDocumentBack && !!addressProof && personalDataComplete;

  const handlePersonalDataChange = (field) => (e) => {
    const value = e.target.value;
    setPersonalData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  // CEP completo → busca no ViaCEP e preenche o endereço. Falha de rede é
  // silenciosa (usuário preenche manualmente); CEP inexistente mostra erro.
  const handleZipcodeChange = (e) => {
    const value = e.target.value;
    setPersonalData((prev) => ({ ...prev, address_zipcode: value }));
    setErrors((prev) => ({ ...prev, address_zipcode: undefined }));

    const digits = value.replace(/\D/g, '');
    if (digits.length !== 8) return;

    axios
      .get(`https://viacep.com.br/ws/${digits}/json/`)
      .then(({ data }) => {
        if (data.erro) {
          setErrors((prev) => ({ ...prev, address_zipcode: 'CEP não encontrado.' }));
          return;
        }
        // CEPs gerais voltam logradouro/bairro vazios — preserva o que o
        // usuário já digitou nesses casos.
        setPersonalData((prev) => ({
          ...prev,
          address_street: data.logradouro || prev.address_street,
          address_neighborhood: data.bairro || prev.address_neighborhood,
          address_city: data.localidade || prev.address_city,
          address_state: data.uf || prev.address_state,
        }));
        setErrors((prev) => ({
          ...prev,
          address_street: undefined,
          address_neighborhood: undefined,
          address_city: undefined,
          address_state: undefined,
        }));
      })
      .catch(() => {});
  };

  function handlePhotoDocumentFrontChange(e) {
    setPhotoDocumentFront(e.target.files?.[0] || null);
    setErrors((prev) => ({ ...prev, photoDocumentFront: undefined, documents: undefined }));
  }

  function handlePhotoDocumentBackChange(e) {
    setPhotoDocumentBack(e.target.files?.[0] || null);
    setErrors((prev) => ({ ...prev, photoDocumentBack: undefined, documents: undefined }));
  }

  function handleAddressProofChange(e) {
    setAddressProof(e.target.files?.[0] || null);
    setErrors((prev) => ({ ...prev, addressProof: undefined, documents: undefined }));
  }

  function submit(e) {
    e.preventDefault();

    if (!photoDocumentFront || !photoDocumentBack || !addressProof) {
      setErrors({
        photoDocumentFront: !photoDocumentFront ? 'Envie a frente do documento com foto.' : undefined,
        photoDocumentBack: !photoDocumentBack ? 'Envie o verso do documento com foto.' : undefined,
        addressProof: !addressProof ? 'Envie o comprovante de residência.' : undefined,
      });
      return;
    }

    setErrors({});
    setSolicitarLoading(true);

    const formData = new FormData();
    formData.append('value', currentUser.balance);
    formData.append('documents[]', photoDocumentFront);
    formData.append('documents[]', photoDocumentBack);
    formData.append('documents[]', addressProof);
    Object.entries(personalData).forEach(([field, value]) => {
      formData.append(field, value);
    });

    axios
      .post('/api/v1/withdrawal_requests', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(function () {
        history.push({
          pathname: '/site/withdrawals',
          state: { dialog: true },
        });
      })
      .catch(function ({ response }) {
        if (response?.status == 422) {
          const data = response.data || {};
          const fieldErrors = {};
          Object.entries(data).forEach(([field, messages]) => {
            fieldErrors[field] = Array.isArray(messages) ? messages.join(', ') : String(messages);
          });
          setErrors({
            ...fieldErrors,
            value: data.value?.join(', '),
            documents: data.documents ? 'Envie os documentos solicitados.' : undefined,
          });
        }
      })
      .then(res => {
        setSolicitarLoading(false);
      });
  };

  return (
    <div className={classes.main}>
      <div className={classes.card}>
        <div className={classes.paper}>
          <Typography className={classes.title}>
            <LocalAtmIcon className={classes.titleIcon} />
            Faça o seu saque
          </Typography>
          <Typography className={classes.subtitle}>
            Faça seu saque com segurança e praticidade
          </Typography>
          <div className={classes.infoBox}>
            <div className={classes.infoTitle}>! Atenção!</div>
            <div className={classes.infoText}>
              Os saques só podem ser realizados para contas bancárias do mesmo titular cadastrado no site,
              utilizando a chave Pix vinculada ao seu CPF.
            </div>
          </div>
          <form className={classes.form} onSubmit={submit} noValidate>
            <div className={classes.valueLabel}>Valor</div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <TextField
                required={true}
                key={'value'}
                id={'value'}
                name={'value'}
                fullWidth={true}
                value={numberAsCurrency(currentUser.balance)}
                error={!!errors.value}
                type={'text'}
                helperText={errors['value'] ? errors['value'] : ''}
                variant="outlined"
                InputProps={{ readOnly: true }}
                className={classes.valueInput}
              />
            </div>
            <div className={classes.documentsLabel}>Dados pessoais</div>
            <div className={classes.documentsHint}>
              Informe seu sexo e endereço. Esses dados são exigidos pela capitalizadora
              para o pagamento da premiação.
            </div>
            <TextField
              select
              id="sex"
              name="sex"
              fullWidth
              value={personalData.sex}
              onChange={handlePersonalDataChange('sex')}
              error={!!errors.sex}
              helperText={errors.sex || ''}
              variant="outlined"
              className={classes.fieldInput}
              SelectProps={{ displayEmpty: true }}
            >
              <MenuItem value="" disabled>Sexo</MenuItem>
              <MenuItem value="F">Feminino</MenuItem>
              <MenuItem value="M">Masculino</MenuItem>
            </TextField>
            <div className={classes.fieldRow}>
              <TextField
                id="address_zipcode"
                name="address_zipcode"
                placeholder="CEP"
                fullWidth
                value={personalData.address_zipcode}
                onChange={handleZipcodeChange}
                error={!!errors.address_zipcode}
                helperText={errors.address_zipcode || ''}
                variant="outlined"
                className={classes.fieldInput}
                InputProps={{ inputComponent: TextMaskZipCode }}
                inputProps={{ inputMode: 'numeric' }}
              />
              <TextField
                select
                id="address_state"
                name="address_state"
                fullWidth
                value={personalData.address_state}
                onChange={handlePersonalDataChange('address_state')}
                error={!!errors.address_state}
                helperText={errors.address_state || ''}
                variant="outlined"
                className={classes.fieldInput}
                SelectProps={{ displayEmpty: true }}
              >
                <MenuItem value="" disabled>Estado (UF)</MenuItem>
                {['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
                  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE',
                  'TO'].map((uf) => (
                  <MenuItem key={uf} value={uf}>{uf}</MenuItem>
                ))}
              </TextField>
            </div>
            <TextField
              id="address_street"
              name="address_street"
              placeholder="Endereço (rua, avenida...)"
              fullWidth
              value={personalData.address_street}
              onChange={handlePersonalDataChange('address_street')}
              error={!!errors.address_street}
              helperText={errors.address_street || ''}
              variant="outlined"
              className={classes.fieldInput}
            />
            <div className={classes.fieldRow}>
              <TextField
                id="address_number"
                name="address_number"
                placeholder="Número"
                fullWidth
                value={personalData.address_number}
                onChange={handlePersonalDataChange('address_number')}
                error={!!errors.address_number}
                helperText={errors.address_number || ''}
                variant="outlined"
                className={classes.fieldInput}
              />
              <TextField
                id="address_complement"
                name="address_complement"
                placeholder="Complemento (opcional)"
                fullWidth
                value={personalData.address_complement}
                onChange={handlePersonalDataChange('address_complement')}
                error={!!errors.address_complement}
                helperText={errors.address_complement || ''}
                variant="outlined"
                className={classes.fieldInput}
              />
            </div>
            <div className={classes.fieldRow}>
              <TextField
                id="address_neighborhood"
                name="address_neighborhood"
                placeholder="Bairro"
                fullWidth
                value={personalData.address_neighborhood}
                onChange={handlePersonalDataChange('address_neighborhood')}
                error={!!errors.address_neighborhood}
                helperText={errors.address_neighborhood || ''}
                variant="outlined"
                className={classes.fieldInput}
              />
              <TextField
                id="address_city"
                name="address_city"
                placeholder="Cidade"
                fullWidth
                value={personalData.address_city}
                onChange={handlePersonalDataChange('address_city')}
                error={!!errors.address_city}
                helperText={errors.address_city || ''}
                variant="outlined"
                className={classes.fieldInput}
              />
            </div>
            <div className={classes.documentsLabel}>Documentos</div>
            <div className={classes.documentsHint}>
              Para cada saque é obrigatório enviar um documento com foto (frente e verso) e um
              comprovante de residência.
            </div>
            <div className={classes.documentInputLabel}>Documento com foto — frente</div>
            <input
              id="photo_document_front"
              name="photo_document_front"
              type="file"
              accept="image/*,application/pdf"
              className={classes.documentsInput}
              onChange={handlePhotoDocumentFrontChange}
            />
            {photoDocumentFront && (
              <div className={classes.documentsList}>{photoDocumentFront.name}</div>
            )}
            {errors.photoDocumentFront && (
              <div className={classes.documentsError}>{errors.photoDocumentFront}</div>
            )}
            <div className={classes.documentInputLabel}>Documento com foto — verso</div>
            <input
              id="photo_document_back"
              name="photo_document_back"
              type="file"
              accept="image/*,application/pdf"
              className={classes.documentsInput}
              onChange={handlePhotoDocumentBackChange}
            />
            {photoDocumentBack && (
              <div className={classes.documentsList}>{photoDocumentBack.name}</div>
            )}
            {errors.photoDocumentBack && (
              <div className={classes.documentsError}>{errors.photoDocumentBack}</div>
            )}
            <div className={classes.documentInputLabel}>Comprovante de residência</div>
            <input
              id="address_proof"
              name="address_proof"
              type="file"
              accept="image/*,application/pdf"
              className={classes.documentsInput}
              onChange={handleAddressProofChange}
            />
            {addressProof && (
              <div className={classes.documentsList}>{addressProof.name}</div>
            )}
            {errors.addressProof && (
              <div className={classes.documentsError}>{errors.addressProof}</div>
            )}
            {errors.documents && (
              <div className={classes.documentsError}>{errors.documents}</div>
            )}
            <LoadingButton
              type="submit"
              fullWidth
              loading={solicitarLoading}
              disabled={!canSubmit}
              variant="contained"
              color="primary"
              className={classes.submit}
              id="submitButton"
            >
              Solicitar
            </LoadingButton>
            <Typography className={classes.helperText}>
              O saque será sempre equivalente ao valor total disponível na sua conta.
              Sua solicitação ficará em análise até a nossa equipe validar os documentos enviados.
              A análise dos documentos é concluída em até 5 dias.
            </Typography>
          </form>
        </div>
      </div>
    </div>
  );
}
